import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Rol } from 'modelos/src';
import { AuthService } from '../entidades/login/auth.service';
import { HelperService } from './servicios/helper.service';

@Injectable({
  providedIn: 'root',
})
export class RolesGuard {
  private helperService = inject(HelperService);
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot) {
    if (this.authService.isLogged()) {
      const rolesPermitidos = route.data.roles as Rol[];
      const rolesUsuario = this.authService.getUsuario()?.roles;
      const clienteAdmin = this.authService.getUsuario()?.cliente?.admin;
      if (clienteAdmin) {
        if (
          !rolesPermitidos?.length ||
          rolesPermitidos.some((rol) => rolesUsuario?.includes(rol))
        ) {
          return true;
        } else {
          this.helperService.notifWarn('Permiso de rol denegado');
          return this.router.parseUrl('/main');
        }
      } else {
        this.helperService.notifWarn('Permiso de cliente denegado');
        return this.router.parseUrl('/login');
      }
    } else {
      this.helperService.notifWarn('Debe iniciar sesión');
      return this.router.parseUrl('/login');
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot) {
    if (this.authService.isLogged()) {
      const rolesPermitidos = route.data.roles as Rol[];
      const rolesUsuario = this.authService.getUsuario()?.roles;
      const clienteAdmin = this.authService.getUsuario()?.cliente?.admin;
      if (clienteAdmin) {
        if (
          !rolesPermitidos?.length ||
          rolesPermitidos.some((rol) => rolesUsuario?.includes(rol))
        ) {
          return true;
        } else {
          this.helperService.notifWarn('Permiso de rol denegado');
          return this.router.parseUrl('/main');
        }
      } else {
        this.helperService.notifWarn('Permiso de cliente denegado');
        return this.router.parseUrl('/login');
      }
    } else {
      this.helperService.notifWarn('Debe iniciar sesión');
      return this.router.parseUrl('/login');
    }
  }
}
